import { authedJson } from '../http';

export interface ActionItem {
  id: number;
  action_type: string;
  title: string;
  symbol: string | null;
  source: string;
  status: string;
  detail: string | null;
  prebuilt_prompt?: string | null;
  read_at?: string | null;
  created_at: string;
}
export interface ActionCreate {
  action_type: string;
  title: string;
  source?: string;
  symbol?: string | null;
  detail?: string | null;
  position_id?: number | null;
}
export function getActions(status?: string): Promise<ActionItem[]> {
  return authedJson(
    'GET',
    `/api/v1/actions${status ? `?status=${encodeURIComponent(status)}` : ''}`
  );
}
export function createAction(body: ActionCreate): Promise<{ id: number; status: string }> {
  return authedJson('POST', '/api/v1/actions', body);
}
export function patchAction(id: number, status: string): Promise<{ id: number; status: string }> {
  return authedJson('PATCH', `/api/v1/actions/${id}`, { status });
}
/** Feed: stamp read_at on one open action item (Task-3 endpoint). */
export function markActionRead(id: number): Promise<{ unread_open: number }> {
  return authedJson('POST', `/api/v1/actions/${id}/read`);
}
/** Feed header: stamp read_at on every open+unread action item (Task-3). */
export function markAllActionsRead(): Promise<{ unread_open: number }> {
  return authedJson('POST', '/api/v1/actions/read-all');
}
export function deleteAction(id: number): Promise<void> {
  return authedJson('DELETE', `/api/v1/actions/${id}`);
}
